import React, { Component } from 'react';
import ReactModal from 'react-modal';
import { IDeleteUserConfirmationModalProps } from './IDeleteUserConfirmationModalProps';
import { IDeleteUserConfirmationModalState } from './IDeleteUserConfirmationModalState';
import styles from './DeleteUserConfirmationModal.module.scss';
import classNames from 'classnames';
import IconButton from "../../../common/buttons/icon-button/IconButton";

class DeleteUserConfirmationModal extends Component<IDeleteUserConfirmationModalProps, IDeleteUserConfirmationModalState> {

  private static removeDialogIndex = 100;

  constructor(props: IDeleteUserConfirmationModalProps) {
    super(props);

    this.state = {
      dialogId: 'delete_user_dialog_' + (DeleteUserConfirmationModal.removeDialogIndex++)
    };

    this.onConfirmClicked = this.onConfirmClicked.bind(this);
  }

  render() {
    return (
      <ReactModal
        appElement={document.getElementById('root') as HTMLElement}
        isOpen={this.props.showDialog}
        id={this.state.dialogId}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        className={classNames([styles.dialog, "shadow p-4"])}
      >
        <h2>Delete user</h2>

        <p>Are you sure you want to delete user <b className={"text-break"}>{this.props.userEmailToDelete}</b>?</p>

        <div className="d-flex justify-content-end">
          <IconButton onClick={this.onConfirmClicked} variant="outline-primary" title="Delete" styles={{marginRight: '1em'}}/>
          <IconButton onClick={this.props.onCancel} variant="outline-primary" title="Cancel"/>
        </div>
      </ReactModal>
    );
  }

  onConfirmClicked() {
    if (this.props.onConfirm !== undefined && this.props.onConfirm !== null) {
      this.props.onConfirm(this.props.userIdToDelete ?? 0);
    }
  }
}

export default DeleteUserConfirmationModal;